export default {
    welcomeTitle: "Welcome to Bwell",
    introText: "Bwell gives you as an employee a personal lifestyle plan and helps you decide how you want your physical, mental, and social life to be going forward. Things that are important to feel well!",
    formTitle: "Log in",
    createAccount: "Create account",
    emailPlaceholder: "Your email address",
    passwordPlaceholder: "Your password",
    togglePasswordAriaLabel: "Show/hide password",
    loading: "Logging in...",
    ok: "OK",
    genericErrorTitle: "An error occurred",
    genericErrorMessage: "Something went wrong. Please try again later.",
    copyright: "© 2025 Bwell Academy. All rights reserved."
  };
